<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800px"
        v-model="dialog"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-list-item v-bind="activatorProps">
                <v-list-item-title>
                    Marcar como realizada
                    <v-icon>mdi mdi-arrow-right</v-icon>
                </v-list-item-title>
            </v-list-item>
        </template>
        <template v-slot:default="{ isActive }">
            <v-card>
                <v-toolbar title="Ingrese token de realización" style="text-align: center;" class="modal-header"></v-toolbar>
                <v-card-text>
                    <p class="my-text-black">
                        Para marcar la solicitud como realizada, ingrese el token de realización proporcionado por la obra social.
                    </p>
                    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
                        <v-text-field
                            v-model="token"
                            :rules="permiteCero ? obligatorioNumerico : obligatorioNumericoSinCero"
                            label="Token de realización"
                            required
                            variant="solo"
                            class="asterisco"
                        ></v-text-field>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                text="Cancelar"
                                id="boton-verde"
                                @click="isActive.value = false"
                                :disabled="cargando == true"
                                :loading="cargando == true"
                            ></v-btn>                            
                            <v-btn
                                id="boton-verde"
                                type="submit"
                                :disabled="!valid || cargando"
                                :loading="cargando"
                                text="Realizar"
                            ></v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card-text>
            </v-card>
        </template>
    </v-dialog>
    
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    />
</template>
<style src="../assets/general.css"></style>
<script>
    import AlertComponent from './AlertComponent.vue';
    import PrestacionService from '@/api/PrestacionService';
    import { obligatorioNumericoSinCero, obligatorioNumerico } from '@/_helpers/rules';

    const prestacionService = new PrestacionService();

    export default {
        name: 'ModalTokenRealizar',
        components: {
            AlertComponent
        },
        props: {
            idSolicitud: {
                type: Number,
                required: true
            },
            permiteCero: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialog: false,
                cargando: false,
                token: '',
                valid: false,
                obligatorioNumericoSinCero : obligatorioNumericoSinCero,
                obligatorioNumerico : obligatorioNumerico,
                // datos del alert
                showAlert: false,
                alertTitle: "",
                alertText: "",
                alertType: ""
            };
        },
        methods: {
            async handleSubmit() {
                const response = await prestacionService.realizarSolicitudAltaComplejidad(
                    this.idSolicitud, 
                    null, 
                    this.token
                );
                this.$emit('solicitud-realizada', response);
            },
        }
    };
</script>